/* Brother Bruno Direct — restyle draft interactions */
(function () {
  'use strict';

  /* ---- tap-to-open Order Now dropdown (matches live storefront behavior) ---- */
  document.querySelectorAll('.nav__drop').forEach(function (drop) {
    var btn = drop.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var open = drop.classList.contains('is-open');
      document.querySelectorAll('.nav__drop').forEach(function (d) { d.classList.remove('is-open'); });
      if (!open) drop.classList.add('is-open');
      btn.setAttribute('aria-expanded', String(!open));
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.nav__drop').forEach(function (d) {
      d.classList.remove('is-open');
      var b = d.querySelector('button');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---- mobile nav ---- */
  var burger = document.querySelector('.burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var h = document.querySelector('.header');
      h.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(h.classList.contains('is-open')));
    });
  }

  /* ---- accordion step panels ---- */
  document.querySelectorAll('.step__bar:not(.step__bar--static)').forEach(function (bar) {
    bar.addEventListener('click', function () {
      var step = bar.closest('.step');
      var open = step.classList.contains('is-open');
      step.parentElement.querySelectorAll('.step').forEach(function (s) {
        if (!s.classList.contains('step--fixed')) s.classList.remove('is-open');
      });
      if (!open) step.classList.add('is-open');
    });
  });

  /* ---- bundle builder ---- */
  var builder = document.getElementById('builder');
  if (!builder) return;

  var photo = document.getElementById('pdpPhoto');
  var hint = document.getElementById('builderHint');
  var atc = document.getElementById('atc');
  var picked = { savory: null, dessert: null };

  function refresh() {
    if (!picked.savory) {
      hint.textContent = 'Pick your savory pizza to continue';
      atc.classList.add('is-locked');
      atc.disabled = true;
    } else if (!picked.dessert) {
      hint.textContent = 'Now pick your dessert pizza';
      atc.classList.add('is-locked');
      atc.disabled = true;
    } else {
      hint.textContent = '';
      atc.classList.remove('is-locked');
      atc.disabled = false;
      atc.textContent = 'Add bundle to cart — $87.98';
    }
    var d2 = document.querySelector('[data-step="dessert"]');
    if (d2) d2.classList.toggle('gated', !picked.savory);
  }

  builder.querySelectorAll('.ptile:not(.ptile--fixed)').forEach(function (tile) {
    tile.addEventListener('click', function () {
      var group = tile.getAttribute('data-group');
      var step = tile.closest('.step');
      step.querySelectorAll('.ptile').forEach(function (t) { t.classList.remove('is-sel'); });
      tile.classList.add('is-sel');
      picked[group] = tile.getAttribute('data-name');

      var pick = step.querySelector('.step__pick');
      if (pick) pick.textContent = picked[group];

      var img = tile.getAttribute('data-photo');
      if (img && photo) photo.src = img;

      refresh();

      if (group === 'savory') {
        step.classList.remove('is-open');
        var next = document.querySelector('[data-step="dessert"]');
        if (next) next.classList.add('is-open');
      } else {
        step.classList.remove('is-open');
      }
    });
  });

  refresh();
})();

/* ---------- press lightbox ---------- */
(function () {
  var lb = document.getElementById('lb');
  if (!lb) return;
  var img = document.getElementById('lbImg');
  var cap = document.getElementById('lbCap');
  var close = document.getElementById('lbClose');

  function open(src, alt, text) {
    img.src = src;
    img.alt = alt || '';
    cap.textContent = text || '';
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    close.focus();
  }
  function shut() {
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
    img.src = '';
  }

  document.querySelectorAll('.shot').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var i = btn.querySelector('img');
      if (i) open(i.getAttribute('src'), i.getAttribute('alt'), btn.dataset.cap || '');
    });
  });
  close.addEventListener('click', shut);
  lb.addEventListener('click', function (e) { if (e.target === lb) shut(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
})();

/* Franchise inquiry -> pre-filled email to the franchise inbox */
(function () {
  var form = document.getElementById('franForm');
  if (!form) return;
  var ok = document.getElementById('franOk');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!form.reportValidity()) return;
    var g = function (n) {
      var el = form.querySelector('[name="' + n + '"]');
      return el && el.value ? el.value.trim() : '';
    };
    var name = g('name'), market = g('market');
    var subject = 'Franchise inquiry' + (name ? ' \u2014 ' + name : '') + (market ? ' (' + market + ')' : '');
    var lines = [
      'Name: ' + (name || '\u2014'),
      'Email: ' + (g('email') || '\u2014'),
      'Phone: ' + (g('phone') || '\u2014'),
      'City and state: ' + (market || '\u2014'),
      'Restaurant experience: ' + (g('experience') || '\u2014'),
      '',
      'About me and my timeline:',
      g('message') || '\u2014',
      '',
      'Sent from brotherbrunodirect.com'
    ];
    var to = form.getAttribute('data-mailto');
    window.location.href = 'mailto:' + to +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(lines.join('\n'));
    if (ok) ok.hidden = false;
  });
})();
